// What actually happened to a service once the tour ran. Kept separate from Booking Status:
// none of these are workflow states, and recording one never moves money.
export const ONTOUR_STATUS_OPTIONS = [
  {value: '', label: '-- OnTour Status --'},
  {value: 'Completed', label: 'Completed — Service Delivered'},
  {value: 'CXL-SNC', label: 'CXL-SNC — Cancellation, Supplier No Charge'},
  {value: 'CXL-SPC', label: 'CXL-SPC — Cancellation, Supplier Partial Charge'},
  {value: 'CXL-SFC', label: 'CXL-SFC — Cancellation, Supplier Full Charge'},
  {value: 'NS-SNC', label: 'NS-SNC — No Show, Supplier No Charge'},
  {value: 'NS-SPC', label: 'NS-SPC — No Show, Supplier Partial Charge'},
  {value: 'NS-SFC', label: 'NS-SFC — No Show, Supplier Full Charge'},
]

// Only the partial-charge codes carry an amount. No-charge implies zero and full-charge
// implies the supplier's purchase price, so neither needs a number stored against it.
export const ONTOUR_PARTIAL_CHARGE_STATUSES = ['CXL-SPC', 'NS-SPC']

export const ontourStatusTakesCharge = (status: string): boolean =>
  ONTOUR_PARTIAL_CHARGE_STATUSES.includes(status)

// Cancellations and no-shows are the ones worth spotting in a long list.
export const ontourStatusTone = (status?: string | null): string => {
  if (!status) return 'secondary'
  if (status === 'Completed') return 'success'
  return status.startsWith('NS-') ? 'danger' : 'warning'
}
